import { mapGetters } from "vuex";
import RequestAPI from '@/api/request';

// 参考https://cn.vuejs.org/v2/guide/plugins.html
export default{
	install(Vue){
		// 1. 添加全局方法或属性
		Vue.myGlobalMethod = function () {
		    // 逻辑...
		}

		// 2. 添加全局资源
		Vue.directive('my-directive', {
		    bind (el, binding, vnode, oldVnode) {
		    	// 逻辑...
			}
		    // ...
		})

		// 3. 注入组件选项
		Vue.mixin({
		    created: function () {
				// 更新浏览器title
				// let title = '';
				// if(this.$route != null && this.$route.meta != null && this.$route.meta.title != null) {
				// 	title = this.$route.meta.title + ' - ';
				// }
				// document.title = title + this.$config.title;
		    },
		    computed:{
	            ...mapGetters([''])
	      	},
		    methods: {
		    	// 定义加载数据的函数
		    	// 查询SOL价格
				async getSOLPrice(){
					let res = await RequestAPI.getSOLPrice();
					let data = res.data;
					let solPrice = data.data[5426].quote.USD.close;
					// 缓存SOL价格
					this.$store.dispatch("solPriceHandler", solPrice)
				}
		  	}
		})
		// 4. 添加实例方法
		Vue.prototype.init = function () {
		    // 在这里加载所需要的初始化数据，放入缓存以便使用
		    this.getSOLPrice();
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/init.js